(function (root, factory) {
	if (typeof exports === "object") {
		module.exports = factory(root);
	} else if (typeof define === "function" && define.amd) {
		define([], factory);
	} else {
		root.LazyLoad = factory(root);
	}
})(typeof global !== "undefined" ? global : this.window || this.global, function (root) {

	"use strict";

	if (typeof define === "function" && define.amd) {
		root = window;
	}

	var defaults = {
		src: "data-src",
		srcset: "data-srcset",
		selector: ".lazyload",
		isLoading: null,
		slide: "swiper",
		bg: "lazy_bg",
		frame: "lazy_frame",
		func: "lazy_func",
		stop: "data-stop",
		update: "data-update",
		simple: "lazy_simple",
		root: null,
		rootMargin: "0px",
		threshold: 0
	};

	/**
	* Merge two or more objects. Returns a new object.
	* @private
	* @param {Boolean}  deep     If true, do a deep (or recursive) merge [optional]
	* @param {Object}   objects  The objects to merge together
	* @returns {Object}          Merged values of defaults and options
	*/
	var extend = function () {

		var extended = {};
		var deep = false;
		var i = 0;
		var length = arguments.length;

		/* Check if a deep merge */
		if (Object.prototype.toString.call(arguments[0]) === "[object Boolean]") {
			deep = arguments[0];
			i++;
		}

		var merge = function (obj) {
			for (var prop in obj) {
				if (Object.prototype.hasOwnProperty.call(obj, prop)) {
					if (deep && Object.prototype.toString.call(obj[prop]) === "[object Object]") {
						extended[prop] = extend(true, extended[prop], obj[prop]);
					} else {
						extended[prop] = obj[prop];
					}
				}
			}
		};

		for (; i < length; i++) {
			var obj = arguments[i];
			merge(obj);
		}

		return extended;
	};

	function LazyLoad(images, options) {
		this.settings = extend(defaults, options || {});
		this.images = images || document.querySelectorAll(this.settings.selector);
		this.observer = null;
		this.slide = document.querySelectorAll(this.settings.slide);
		this.init();
	}

	LazyLoad.prototype = {
		init: function () {

			var self = this;
			var isLeaving = false;
			var observerConfig = {
				root: this.settings.root,
				rootMargin: this.settings.rootMargin,
				threshold: [this.settings.threshold]
			};

			this.observer = new IntersectionObserver(function (entries) {
				Array.prototype.forEach.call(entries, function (entry) {
					if (entry.isIntersecting) {
						var src = entry.target.getAttribute(self.settings.src);
						var srcset = entry.target.getAttribute(self.settings.srcset);
						if ("img" === entry.target.tagName.toLowerCase()) {
							self.observer.unobserve(entry.target);
							if (src) {
								entry.target.src = src;
							}
							if (srcset) {
								entry.target.srcset = srcset;
							}
						} else if ("picture" === entry.target.tagName.toLowerCase()) {
							self.observer.unobserve(entry.target);
							var sources = entry.target.querySelectorAll('source');
							sources.forEach(function (source) {
								var sss = source.getAttribute(self.settings.srcset);
								if (sss) source.srcset = sss;
							})
						} else if ("video" === entry.target.tagName.toLowerCase()) {
							if (!entry.target.classList.contains(self.settings.simple)) {
								var video = entry.target.getAttribute('data-src');
								var video2x = entry.target.getAttribute('data-srcset');
								if (document.body.clientWidth < 670) {
									entry.target.src = video;
								} else {
									if (window.devicePixelRatio < 2) {
										entry.target.src = video;
									} else {
										entry.target.src = video2x;
									}
								}
								self.observer.unobserve(entry.target);
							}
						} else if (entry.target.classList.contains(self.settings.bg) && !entry.target.classList.contains(self.settings.slide)) {
							if (window.devicePixelRatio < 2) {
								var bgImg = entry.target.getAttribute('data-src');
								bgImg === null ? bgImg = entry.target.getAttribute('data-all') : '';
							} else {
								var bgImg = entry.target.getAttribute('data-src-2x');
								bgImg === null ? bgImg = entry.target.getAttribute('data-all') : '';
							}
							self.observer.unobserve(entry.target);
							if (bgImg) {
								entry.target.style.backgroundImage = "url(" + bgImg + ")";
							}
						} else if (entry.target.classList.contains(self.settings.frame) && !entry.target.classList.contains(self.settings.slide)) {
							var iframe = entry.target.getAttribute('data-src');
							self.observer.unobserve(entry.target);
							entry.target.src = iframe;
						} else if (entry.target.classList.contains(self.settings.func) && !entry.target.classList.contains(self.settings.slide)) {
							var funcName = entry.target.getAttribute('data-func');
							self.observer.unobserve(entry.target);
							MG.lazyload.init(funcName);
						}
						if (entry.target.classList.contains(self.settings.slide)) {
							isLeaving = true;
							var mySwiper = entry.target.id;
							if (entry.target.classList.contains("swiper-initialized")) {
								window[mySwiper].autoplay.start();
								entry.target.setAttribute(self.settings.stop, 'false');
								if (entry.target.getAttribute('data-update') == 'false') {
									setTimeout(function () {
										window[mySwiper].update();
									}, 1000);
									entry.target.setAttribute(self.settings.update, 'true');
								}
							}
						}
						// if (entry.target.getAttribute('data-video') == 'true') {
						// 	isLeaving = false;
						// 	setSlideActive(0);
						// 	setBarActive(0);
						// 	//ниже 3 строки для того чтобы не сразу видео запускалось а по клику
						// 	document.body.classList.add("paused");
						// 	cancelAnimation();
						// 	pauseVideo();
						// 	// slidesAutoPlay();
						// 	entry.target.setAttribute('data-video', 'false');
						//  self.observer.unobserve(entry.target);
						// }
						entry.target.classList.add('loaded');
						if (self.settings.isLoading) {
							entry.target.addEventListener('load', function () {
								entry.target.classList.remove(isLoading);
							});
						}
					} else if (entry.target.getAttribute('data-stop') == 'false' && entry.target.classList.contains(self.settings.slide)) {
						isLeaving = false;
						var mySwiper = entry.target.id;
						window[mySwiper].autoplay.stop();
						entry.target.setAttribute(self.settings.stop, 'true');
					}
				});
			}, observerConfig);

			Array.prototype.forEach.call(this.images, function (image) {
				self.observer.observe(image);
			});
		},

		loadAndDestroy: function () {
			if (!this.settings) { return; }
			this.destroy();
		},

		destroy: function () {
			if (!this.settings) { return; }
			this.observer.disconnect();
			this.settings = null;
		}
	};

	root.lazyload = function (images, options) {
		return new LazyLoad(images, options);
	};

	return LazyLoad;
});